import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import config from '../config';
import { createAuth } from '../Helpers';

export const reducerName = 'deviceState';

export const getAllDevices = createAsyncThunk(
    'deviceStore/getAllDevices',
    async (_, { getState, rejectWithValue }) => {
        const deviceId = localStorage.getItem('deviceId') || getState().authState.deviceId;
        if (!deviceId) return {};
        try {
            const response = await axios({
                method: 'GET',
                url: `${config.server}/api/device/${deviceId}`,
                withCredentials: true,
                auth: createAuth(getState),
            });
            return response.data;
        } catch (error) {
            console.error('ERROR FETCHING DEVICES', error);
            return rejectWithValue(error.response?.data || 'An error occurred');
        }
    }
);

const initialState = {
    device: {},
    status: 'idle',
    error: null,
};

const deviceSlice = createSlice({
    name: reducerName,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllDevices.pending, (state) => {
                state.status = 'loading';
                state.error = null; 
            })
            .addCase(getAllDevices.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.device = action.payload; 
            })
            .addCase(getAllDevices.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload || 'An error occurred'; 
            });
    },
});

export default deviceSlice.reducer;